import CommonHead from './CommonHead.vue';
import CommonTable from './CommonTable.vue';
import CommonForm from './CommonForm.vue';
import IframeContainer from './IframeContainer.vue';
export default {
  CommonHead,
  CommonTable,
  CommonForm,
  IframeContainer
};